import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';
import { GtsAppTableNamesEnum } from '../gts/models/app-table-names.enum';
import { TableMigrationStatusEnum } from '../gts/models/table-migration-status.enum';

@Entity('t_migration_log')
export class MigrationLogEntity {
    @PrimaryGeneratedColumn('increment', {
        name:'id'
    })
    id: string;

    @Column('varchar', {
        nullable: false,
        length: 5,
        name: 'unit_id'
    })
    unitId: string;
    
    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'table_name'
    })
    tableName: GtsAppTableNamesEnum;

    @Column('date', {
        nullable: false,
        name: 'migration_date',
        default: ()=>'CURRENT_DATE'
    })
    migrationDate: string;

    @Column('tinyint', {
        nullable: false,
        name: 'hour'
    })
    hour: number;

    @Column('tinyint', {
        nullable: false,
        default: 0,
        name: 'status'
    })
    status: TableMigrationStatusEnum;

    @Column('text', {
        nullable: true,
        name: 'fail_reason'
    })
    failReason: string;

}